import { useEffect, useState } from 'react';
import { SRFBridge } from 'srf-native-bridge';
import { MEDIA_CLICKED } from '@fec/assets/js/utils/event';
import { PREMATURE_MEDIA_PLAYBACK_EVENTS } from '@aron/common/bridge/main.js';

const usePlayerAppEvents = (urn, payload) => {
  const [hasActivePlayer, setHasActivePlayer] = useState(false);

  // BRIDGE events
  // -> handling the MediaPlaybackStatus event from the bridge
  useEffect(() => {
    const handleMediaPlaybackStatus = ({ payload }) => {
      if (payload.playbackState === 'PLAYING' && payload.urn === urn) {
        setHasActivePlayer(true);
      } else {
        setHasActivePlayer(false);
      }
    };
    // replay media playback events received before the event handler was registered
    PREMATURE_MEDIA_PLAYBACK_EVENTS.map((payload) =>
      handleMediaPlaybackStatus({ payload }),
    );

    SRFBridge.addListener('MediaPlaybackStatus', handleMediaPlaybackStatus);

    // No cleanup possible since SRFBridge has no removeListener method...
  }, [urn]);

  // WEBVIEW events
  // -> handling clicks on the media in the webview
  useEffect(() => {
    const handleMediaClickedEvent = ({ detail }) => {
      if (detail.urn === urn && !hasActivePlayer) {
        setHasActivePlayer(true);
      } else {
        setHasActivePlayer(false);
      }
    };

    window.addEventListener(MEDIA_CLICKED, handleMediaClickedEvent);
    return () =>
      window.removeEventListener(MEDIA_CLICKED, handleMediaClickedEvent);
  }, [urn, hasActivePlayer]);

  const dispatchMediaClickedEvents = () => {
    /* notify the bridge */
    if (payload.EventType === 'Video') {
      SRFBridge.playVideo(payload.EventPayload);
    } else if (payload.EventType === 'Audio') {
      SRFBridge.playAudio(payload.EventPayload);
    } else if (payload.EventType === 'Livestream') {
      SRFBridge.playLivestream(payload.EventPayload);
    }

    /* notify the webview */
    const clickedEvent = new CustomEvent(MEDIA_CLICKED, {
      detail: { urn: urn },
    });
    window.dispatchEvent(clickedEvent);
  };

  const dispatchMediaStoppedEvents = () => {
    /* notify the bridge */
    SRFBridge.mediaPlaybackStatus('STOPPED', urn);

    /* notify the webview */
    const clickedEvent = new CustomEvent(MEDIA_CLICKED, {
      detail: { urn: urn },
    });
    window.dispatchEvent(clickedEvent);
  };

  return {
    dispatchMediaClickedEvents,
    dispatchMediaStoppedEvents,
    hasActivePlayer,
  };
};

export default usePlayerAppEvents;
